import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';

import { PaginatedResults } from '../activity/types';

/**
 *  Fetches data from the given URL and returns the results with pagination.
 */
export async function fetchWithPagination<T>(url: string, opts?: RequestInit) {
  const {
    pagination: { limit, offset, totalResults },
    results: firstResults,
  } = await fetchWithToken<PaginatedResults<T>>(`${url}&limit=1`, opts);

  const hasNextPage = totalResults > offset + limit;

  if (hasNextPage) {
    const urls = [];
    for (let index = 1; index < totalResults / limit; index++) {
      urls.push(`${url}&offset=${offset + limit * index}`);
    }

    const restResultsArray = await Promise.all(
      urls.map(async (url) => {
        const { results } = await fetchWithToken<PaginatedResults<T>>(
          url,
          opts,
        );
        return results;
      }),
    );
    const restResults = restResultsArray.map(
      (restResultArray) => restResultArray[0],
    );

    return [...firstResults, ...restResults];
  }

  return firstResults;
}
